import classNames from 'classnames'
import React, { ReactNode } from 'react'

import './Banner.scss'

const Banner = ({
  firstLine,
  secondLine,
  subLine,
}: {
  firstLine: string
  secondLine?: string
  subLine?: ReactNode
}) => (
  <div className="banner">
    <div className="banner__container gutter gutter--center">
      <div
        className={classNames('banner__main', {
          'banner__main--huge': !subLine,
        })}
      >
        {[firstLine, secondLine].join('\n')}
      </div>
      {subLine && <div className="banner__sub">{subLine}</div>}
    </div>
  </div>
)

export default Banner
